<template>
  <div id="audiologyKPIs">
    <AudiologyKpis v-if="hasData"></AudiologyKpis>
    <Teaser v-else></Teaser>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import AudiologyKpis from '../audiology-kpis/AudiologyKpis.vue';
  import Teaser from '../audiology-kpis/Teaser.vue';

  export default {
    name: 'AudiologyKpisLayout',
    components: {
      AudiologyKpis,
      Teaser,
    },
    async created() {
      if (!this.initializers.years) {
        await this.$store.dispatch('audiologyKpis/getAudiologyKpisYears');
      }
    },
    computed: {
      ...mapGetters('audiologyKpis', ['initializers', 'hasData']),
    },
  };
</script>
